<template>
	<div>
		<van-nav-bar :title="pagetitle" fixed placeholder z-index="99" :border="false" v-if="isMobileFlag" left-arrow @click-left="onClickLeft" />
		<div class="signle-header" v-if="!isMobileFlag">
			<div class="layui-container">
				<div class="logo"><router-link to='/'><img :src="$helper.get('rule').app_logo" alt=""></router-link></div>
			</div>
		</div>
	</div>
</template>

<script>
	import helper from '@/common/helper.js';
	export default {
		components: {
		},
		props: {
			pagetitle: {
				type:String,
				default:""
			},
		},
		data() {
			return {};
		},
		computed: {},
		methods: {
			onClickLeft() {
				this.$router.go(-1);
			},
		},
		mounted() {}
	}
</script>